// extracted by mini-css-extract-plugin
module.exports = {"map":"styles_map_PFLIB1Z6IDv1Mwp_Q6hr_"};